export const CNP_STEPS = [
  "Energy and Asset Profile",
  "Economic Sustainability",
  "Report Generation",
];

export const CNP_TABS = {
  0: [
    { key: "1.A", value: "Energy System" },
    { key: "1.B", value: "Carbon Emission Profile at Asset Level" },
    { key: "1.C", value: "Emission Reduction Plan Summary" },
    { key: "1.D", value: "Overall Energy Profile" },
  ],
  1: [
    { key: "2.A", value: "CAPEX" },
    { key: "2.B", value: "OPEX" },
    { key: "2.C", value: "NPV and Payback Period" },
    { key: "2.D", value: "Levelized Cost" },
  ],
};

export const ENERGY_SYSTEM_OPTIONS = [
  { value: "Electricity", key: "electricity" },
  { value: "Heat", key: "heat" },
  { value: "Cooling", key: "cooling" },
  { value: "Fuel", key: "fuel" },
];

export const ASSET_TYPE_OPTIONS = [
  {
    value: "Steam Turbine",
    key: "steam_turbine",
    energySystem: "electricity",
  },
  { value: "Gas Engine", key: "gas_engine", energySystem: "electricity" },
  { value: "Solar PV", key: "solar_pv", energySystem: "electricity" },
  {
    value: "Wind Turbine",
    key: "wind_turbine",
    energySystem: "electricity",
  },
  {
    value: "Energy Storage System",
    key: "energy_storage_system",
    energySystem: "electricity",
  },
  { value: "Others", key: "other", energySystem: "electricity" },
  { value: "Boiler", key: "boiler", energySystem: "heat" },
  { value: "Heat Pump", key: "heat_pump", energySystem: "heat" },
  { value: "Heat Exchanger", key: "heat_exchanger", energySystem: "heat" },
  {
    value: "Thermal Storage System",
    key: "thermal_storage_system",
    energySystem: "heat",
  },
  { value: "Others", key: "other", energySystem: "heat" },
  { value: "Vapour Chiller", key: "vapour_chiller", energySystem: "cooling" },
  {
    value: "Absorption Chiller",
    key: "absorption_chiller",
    energySystem: "cooling",
  },
  { value: "Others", key: "other", energySystem: "cooling" },
];

export const INPUT_OPTIONS = [
  { value: "Fuel", key: "fuel" },
  { value: "Solar", key: "solar" },
  { value: "Wind", key: "wind" },
  { value: "Electricity", key: "electricity" },
  { value: "Heat", key: "heat" },
  { value: "Cooling", key: "cooling" },
  { value: "External Energy Resource", key: "external" },
];

export const OUTPUT_OPTIONS = [
  { value: "Electricity", key: "electricity" },
  { value: "Heat", key: "heat" },
  { value: "Cooling", key: "cooling" },
  { value: "Grid", key: "grid" },
  { value: "Energy Carrier", key: "energy_carrier" },
  { value: "Other", key: "other" },
];

export const EXTERNAL_OPTIONS = [
  { value: "Grid", key: "grid" },
  { value: "District Heat", key: "district_heat" },
  { value: "District Cooling", key: "district_cooling" },
  { value: "Other", key: "other" },
];

export const PATHWAY_OPTIONS = [
  { value: "Energy mix", key: "energy_mix" },
  { value: "Energy efficiency", key: "energy_efficiency" },
  { value: "Electrification", key: "electrification" },
  { value: "Sustainable fuel", key: "sustainable_fuel" },
  { value: "Plant optimization", key: "plant_optimization" },
  {
    value: "Carbon capture and storage",
    key: "carbon_capture_and_storage",
  },
  { value: "Others", key: "other" },
];

export const EMISSION_SCOPE_OPTIONS = [
  { value: "Scope 1", key: 1 },
  { value: "Scope 2", key: 2 },
  { value: "Scope 3", key: 3 },
];

export const ENERGYASSETINITIAL = {
  energySystem: "",
  assetType: "",
  assetName: "",
  assetInfo: {
    capacity: "",
    noOfUnit: "",
    opHr: "",
    coefficient: "",
    efficiency: "",
    input: "",
    output: "",
    configuration: true,
    fuelInfo: {},
    externalInfo: {},
  },
};

export const NPVINITIAL = {
  energySystem: "",
  assets: [],
  productName: "",
  production: null,
  price: null,
  residualValue: null,
  interestRate: null,
  noOfYrs: null,
};

export const LCOEINITIAL = {
  energySystem: "",
  assets: [],
  interestRate: null,
  noOfYrs: null,
  residualValue: null,
  annualProduction: null,
  production: "",
};

export const GWP_VALUES = {
  co2GWP: 1,
  ch4GWP: 27.9,
  n2oGWP: 273,
};

export const CUSTOM_REPORT_INITIAL = {
  templateName: "",
  companyName: "",
  reportingDate: new Date(),
  companyLogo: [],
};

export const MITIGATION_OPTIONS = [
  { key: "offsets", value: "Offsets (Carbon Credit)" },
  { key: "recs", value: "RECs" },
  { key: "other", value: "Others" },
];

export const MITIGATION_UNITS = [
  { key: "tco2e", value: "tCO₂e" },
  { key: "mwh", value: "MWh" },
];

export const MITIGATION_INITIAL = {
  mitigationApplied: null,
  types: [],
};

export const MITIGATION_SCOPES_INITIAL = [
  {
    isCovered: null,
    projectName: null,
    scope: 1,
    quantity: null,
    unit: null,
    emissionFactor: null,
    date: new Date(),
  },
  {
    isCovered: null,
    projectName: null,
    scope: 2,
    quantity: null,
    unit: null,
    emissionFactor: null,
    date: new Date(),
  },
  {
    isCovered: null,
    projectName: null,
    scope: 3,
    quantity: null,
    unit: null,
    emissionFactor: null,
    date: new Date(),
  },
];
